import React from 'react';
import { GameState, Player, PlayerHistoryRecord, TransferHistoryRecord } from '../../../domain/entities';
import { View } from '../../../App';
import { AdPlaceholder } from '../../shared/AdPlaceholder';
import { PlayerTransferHistoryPanel } from './PlayerTransferHistoryPanel';
import { PlayerCareerHistoryPanel } from './PlayerCareerHistoryPanel';
import { PlayerValueChart } from '../../shared/PlayerValueChart';
import { PlayerDevelopmentHistoryPanel } from '../../shared/PlayerDevelopmentHistoryPanel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAmbulance } from '@fortawesome/free-solid-svg-icons';

interface PlayerHistoryTabProps {
    player: Player;
    gameState: GameState;
    adsEnabled: boolean;
    augmentedHistory: TransferHistoryRecord[];
    careerHistoryForDisplay: PlayerHistoryRecord[];
    teamName: string;
    pushView: (view: View) => void;
    teamColorsMap: Record<string, string>;
}

export const PlayerHistoryTab: React.FC<PlayerHistoryTabProps> = ({
    player, gameState, adsEnabled, augmentedHistory, careerHistoryForDisplay, teamName, pushView, teamColorsMap
}) => {
    return (
        <div className="player-detail-tab-content">
            {adsEnabled && <AdPlaceholder />}
            <PlayerCareerHistoryPanel player={player} gameState={gameState} teamName={teamName} pushView={pushView} />
            <PlayerTransferHistoryPanel transferHistory={augmentedHistory} gameState={gameState} pushView={pushView} />
            <div className="panel">
                 <div className="panel-header">Market Value History</div>
                 <div className="panel-content" style={{ padding: 0 }}>
                    <PlayerValueChart 
                        marketValueHistory={player.marketValueHistory}
                        careerHistory={careerHistoryForDisplay}
                        transferHistory={augmentedHistory}
                        teamColorsMap={teamColorsMap}
                    />
                </div>
            </div>
            <div className="panel">
                <div className="panel-header">Development History</div>
                <div className="panel-content" style={{padding: 0}}>
                    <PlayerDevelopmentHistoryPanel player={player} />
                </div>
            </div>
            {player.injuryHistory && player.injuryHistory.length > 0 && (
                <div className="panel">
                    <div className="panel-header" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FontAwesomeIcon icon={faAmbulance} className="negative" />
                        <span>Injury History</span>
                    </div>
                    <div className="panel-content" style={{padding: 0}}>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Season</th>
                                    <th>Week</th>
                                    <th>Type</th>
                                    <th style={{ textAlign: 'right' }}>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...player.injuryHistory].reverse().map((injury, index) => (
                                    <tr key={index}>
                                        <td>{injury.season}</td>
                                        <td>{injury.week}</td>
                                        <td>
                                            <span className={injury.type === 'Severe' ? 'text-error' : 'text-warning'} style={{ fontWeight: 'bold' }}>
                                                {injury.type}
                                            </span>
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            {injury.duration} {injury.duration === 1 ? 'week' : 'weeks'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};